module.exports = __webpack_public_path__ + "img/yelp.33bba85a.svg";